import type { FC } from 'react';

// Externals
import { Box } from '@mui/material';

const SplashScreen: FC = () => (
  <Box
    sx={{
      alignItems: 'center',
      backgroundColor: 'background.default',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      justifyContent: 'center',
      left: 0,
      p: 3,
      position: 'fixed',
      top: 0,
      width: '100%',
      zIndex: 2000
    }}
  >
    <img alt="logo" src="/static/images/appetito.png" width="140" />
  </Box>
);

export default SplashScreen;
